// Corners of a unit square drawn as a triangle strip: (0,0) (1,0) (0,1) (1,1)
const UNIT_QUAD_CORNERS = new Float32Array([0, 0, 1, 0, 0, 1, 1, 1]);
const CORNER_COMPONENTS = 2;

export const UNIT_QUAD_VERTEX_COUNT = 4;

/**
 * Creates the per-vertex buffer of a unit square and binds it to attribute
 * location 0 of the currently bound vertex array. Every instance of an
 * instanced renderer is this square stretched by the vertex shader.
 *
 * @param {WebGL2RenderingContext} gl
 * @returns {WebGLBuffer}
 */
export const bindUnitQuad = (gl) => {
  const buffer = gl.createBuffer();

  gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
  gl.bufferData(gl.ARRAY_BUFFER, UNIT_QUAD_CORNERS, gl.STATIC_DRAW);
  gl.enableVertexAttribArray(0);
  gl.vertexAttribPointer(0, CORNER_COMPONENTS, gl.FLOAT, false, 0, 0);

  return buffer;
};

/**
 * Describes per-instance float attributes laid out one after another in the
 * currently bound ARRAY_BUFFER, starting at location 1.
 *
 * @param {WebGL2RenderingContext} gl
 * @param {number[]} componentCounts - components of each attribute, in order
 */
export const bindInstanceAttributes = (gl, componentCounts) => {
  const bytesPerFloat = Float32Array.BYTES_PER_ELEMENT;
  const stride = componentCounts.reduce((sum, count) => sum + count, 0) * bytesPerFloat;
  let offset = 0;

  componentCounts.forEach((count, index) => {
    const location = index + 1;

    gl.enableVertexAttribArray(location);
    gl.vertexAttribPointer(location, count, gl.FLOAT, false, stride, offset);
    gl.vertexAttribDivisor(location, 1);
    offset += count * bytesPerFloat;
  });
};
